import { useTrial } from '../TrialProvider';
import { useReportingTrial } from '../useReportingTrial';

import { deriveConsoleAccess } from './deriveConsoleAccess';
import type { ConsoleAccess } from './types';

/** Composes reporting + PLG trial hooks into named console capabilities. */
export const useConsoleAccess = (): ConsoleAccess => {
  const reporting = useReportingTrial();
  const plg = useTrial();

  // Fail closed while reporting status loads — avoid flashing automation nav.
  if (reporting.isLoading) {
    return {
      limitAutomationConsole: true,
      showReportingTrialBadge: false,
      showAutomationUpsell: false,
      showAutomationOverviewNav: false,
    };
  }

  return deriveConsoleAccess(
    { isEligible: reporting.isEligible, state: reporting.state },
    { state: plg.state }
  );
};
